const FEEDBACK_SUBMITTER_ROLES = [
  'school_admin',
  'principal',
  'teacher',
  'student',
  'parent',
  'receptionist',
  'staff',
];

export function canSubmitFeedback(user) {
  if (!user) return false;
  if (user.school_observer_mode) return false;
  const role = String(user.role_slug || '').toLowerCase().trim();
  return FEEDBACK_SUBMITTER_ROLES.includes(role);
}

export function isSuperAdminFeedbackUser(user) {
  return String(user?.role_slug || '').toLowerCase() === 'super_admin' && !user?.school_observer_mode;
}

export function canManageSchoolFeedback(user) {
  if (!user || user.school_observer_mode) return false;
  const role = String(user.role_slug || '').toLowerCase().trim();
  return role === 'school_admin' || role === 'principal';
}
